import {
    TrackFilterEventType,
    FilterType,
    FilterTypeEvent,
    TrackFilterEventProperty
} from '@utils/gtm-tracking/model/FilterType';
import { Params } from '@angular/router';

export const listOfFiltersToBeTracked: TrackFilterEventType[] = ['filter_brand', 'filter_color', 'filter_material'];

const mapToFilterTypeEvent = (event: FilterType): TrackFilterEventType => {
    // special cases where we can map directly to the filter_xxx
    if (event === 'primaryColor') {
        return `filter_color`;
    }
    if (event === 'materialMulti') {
        return `filter_material`;
    }

    return `filter_${event}`;
};

const mapToFilterEventProperty = (event: FilterType): TrackFilterEventProperty => {
    if (event === 'primaryColor') {
        return 'color';
    }

    if (event === 'materialMulti') {
        return 'material';
    }

    return event;
};

export const getFilterTypeEventAndValue = (params: Params): FilterTypeEvent | undefined =>
    Object.keys(params)
        .map(param => {
            const [first] = param.split('.') as FilterType[];
            return {
                event: mapToFilterTypeEvent(first),
                property: mapToFilterEventProperty(first),
                value: params[param]
            };
        })
        .find(filter => listOfFiltersToBeTracked.includes(filter.event as TrackFilterEventType)) as FilterTypeEvent;
